
/**
 *  Changes the navigation bar state
 *
 *  @param  {number} state [state to be changed in the navigation bar]
 */
export function changeNavState(state: number) {
    return {
        type: 'NAVBAR_SET_STATE',
        payload: state,
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/navbar.ts